import { z } from 'zod'

export const nkdaSchema = z.object({
  id: z.string(),
  patient: z.number(),
  created_date: z.string(),
  deleted_date: z.string().nullable(),
})

export type NKDA = z.infer<typeof nkdaSchema>
